import React, { useContext } from "react";

import NoData from "../NoData.js";
import { DataContext } from "../../Context/DataContext.js";
import { searchClientAlgolia } from "../../firebase.config.js";
import AdminNotificationsComponent from "./AdminNotificationsComponent.js";
import { InstantSearch } from "react-instantsearch-hooks-web";
import useClientNotifications from "../../Hooks/useFetchClientNotifications.js";

const AdminNotifications = ({ windowSize }) => {

  const { userData } = useContext(DataContext);
  const notifications = useClientNotifications(userData);

  if (!userData) {
    return <NoData loading={true} showBtn={false} loadingText={"invoices"} type="quotes" />
  }

  return (
    <>
      {/* <TopBar /> */}
      <InstantSearch searchClient={searchClientAlgolia} indexName="orders" >
        <AdminNotificationsComponent windowSize={windowSize} notifications={notifications} />
      </InstantSearch>
    </>
  );
};

export default AdminNotifications;
